<!--
  @author:chen.hao
  @time:2018/11/7
  @disc:报价管理审批弹出层
 -->

<template>
  <el-dialog
    title="审核"
    :visible.sync="visible"
    width="800px"
    @close="handleClose">
    <info :info-data="info"></info>
    <el-form ref="form" :model="form" label-width="100px">
      <div class="info-block">
        <el-form-item label="审批信息" class="title-info"></el-form-item>
        <el-form-item label="审批结果" prop="result">
          <el-radio-group v-model="form.result">
            <el-radio v-for="item in resultArr" :label="item.value" :key="item.value">{{item.label}}</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import Info from './info'
export default {
  name: 'reviewDialog',
  components: { Info },
  props: ['show', 'info'],
  data () {
    return {
      visible: this.show,
      form: {
        result: 3
      },
      resultArr: [
        { value: 3, label: '通过' },
        { value: 2, label: '未通过' }
      ]
    }
  },
  methods: {
    ...mapActions(['reviewQuote', 'getQuoteList']),
    handleClose () {
      this.$emit('update:show', false)
      this.$refs.form.resetFields()
    },
    submit () {
      const params = {
        ...this.form,
        id: this.info.id
      }
      this.reviewQuote(params)
        .then(() => {
          return this.getQuoteList()
        })
        .then(() => {
          this.visible = false
        })
    }
  },
  watch: {
    show () {
      this.visible = this.show
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .title-info .el-form-item__label {
  font-weight: bold;
  font-size: 16px;
  width: auto !important;
}
</style>
